module.exports = __webpack_public_path__ + "static/media/25-12.c9bee383.mp3";